module.exports = __webpack_public_path__ + "img/tiankang.3cfde527.jpeg";